<template>
    <section class="test-drive">
        <PreviousStep />
        <div class="select-datetime__content" id="target-section">
            <div class="select-datetime__content--details">
                <selected-vehicle-details :model="model" :dealership="dealer.name"></selected-vehicle-details>
            </div>
            <div class="select-datetime__content--main">
                <div class="card select-datetime__calender">
                    <p class="select-datetime__title">Please choose a date: <span class="select-datetime__date">{{ date }}</span></p>
                    <div class="select-datetime__content--form">
                        <div class="select-datetime__content--input">
                        <div v-if="loadingDays == false">
                            <date-picker :closedDays="closedDays" :minDate="minDate" :maxDate="maxDate"></date-picker>
                        </div>
                        </div>
                    </div>
                    <div v-if="times.length > 0" class="select-datetime__content--options">
                        <p class="select-datetime__title">Preferred time of collection:</p>
                        <div class="select-datetime__times-grid">
                        <template v-for="time in times">
                            <div :key="time"
                            :class="{ 'select-datetime__time-option': true, 'select-datetime__selected-time': time === chosenTime }"
                            @click="handleTimeSelection(time)"
                            >
                            {{ time }}
                            </div>
                        </template>
                        </div>
                    </div>
                    <div class="select-datetime__content--button">
                        <button type="button" class="btn btn-primary select-datetime__button" @click="selectDateTime()">
                            CONTINUE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PreviousStep from "../PreviousStep";
import SelectedVehicleDetails from "../SelectedVehicleDetails.vue"
import DatePicker from "../DatePicker.vue"
import EventObject from "../../../../modules/tracking/EventObject";
import { addDays, setMonth, endOfMonth } from 'date-fns';

export default {
    components: {
        SelectedVehicleDetails,
        PreviousStep,
        DatePicker
    },
    data() {
        return {
            chosenDate:null,
            chosenTime:null,
            minDate: null,
            maxDate: null,
            dayTimes: null,
            bankHolidays: [],
        };
    },
    mounted() {
        if (this.datePage === true) {
            new EventObject("Electric Car - Test Drive Form", "Revisit", "Date Page").dispatch();
        } else {
            new EventObject("Electric Car - Test Drive Form", "Visited", "Date Page").dispatch();
            this.$store.commit("setDatePage", true);
        }
    },
    created() {
        this.$nextTick(() => {
            this.scrollToTop();
        });

        this.minDate = addDays(new Date(), 4);
        this.maxDate = addDays(new Date(), 90); 
    },
    methods: {
        selectDateTime(dealership) {
            if (this.haveMinimumData == true) {
                this.$store.dispatch("navigatorStep", this.currentStep.next);
            }
        },
        handleTimeSelection(time) {
            this.chosenTime = time;
            this.$store.commit("setTime",  this.chosenTime);
        },
        scrollToTop() {
            const storedPosition = this.scrollPosition;
            if (storedPosition) {
                window.scrollTo({ top: storedPosition, behavior: 'smooth' });
            }
        },
    },
    computed: {
        ...mapGetters(["currentStep", 'model', 'getDealerClosedDays', 'getDealerBankHolidays']),
        ...mapState(['dealer', 'date', 'times', 'time', 'loadingDays', 'datePage','scrollPosition']),

        haveMinimumData() {
            if (!this.date) {
                return false;
            }
            if (!this.time) {
                return false;
            }
            return true;
        },

        closedDays(){
            return this.getDealerClosedDays.concat(this.getDealerBankHolidays)
        },
    },
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/electric-test-drive/steps/DateSelect.vue